import React from 'react';

const StepNotes = ({ step }) => {
  const notes = {
    1: (
      <>
        <p>
          Setting the financial year defines the boundaries for your entire accounting period.
          This helps organize reports, taxes, and transactions.
        </p>
        <p className="text-muted">
          This assistant assumes you are starting fresh with no previous data.
        </p>
      </>
    ),
    2: (
      <>
        <p>
          Enter the net result <strong>(profit or loss)</strong> from the previous year.
          This helps the system balance your opening equity.
        </p>
        <p><strong>Note:</strong> Profit must be entered as a positive number, and loss as a negative number e.g. -5000 for loss or 5000 for profit.</p>
      </>
    ),
    3: (
      <p>
        List all your organization's current assets as of the opening day.
        <br />
        <em>Examples: Cash, Bank, Inventory.</em>
      </p>
    ),
    4: (
      <p>
        Record all liabilities owed by the organization.
        <br />
        <em>Examples: Loans, Payables, Tax Obligations.</em>
      </p>
    ),
    5: (
      <p>
        Confirm everything before we set up your books.
        <br />
        You can always edit this data later.
      </p>
    )
  };

  return <div className="text-secondary fw-light">{notes[step]}</div>;
};

export default StepNotes;
